var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedComplaince(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_2074_124383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.434 11.7617C10.9124 11.7617 8.86719 13.9422 8.86719 16.6304C8.86719 19.3187 10.9124 21.4992 13.434 21.4992C15.9556 21.4992 18.0008 19.3187 18.0008 16.6304C17.9977 13.9422 15.9556 11.7651 13.434 11.7617ZM13.434 20.1282C11.623 20.1282 10.1531 18.5628 10.1531 16.6304C10.1531 14.698 11.6214 13.1327 13.434 13.1327C15.245 13.1327 16.7149 14.698 16.7149 16.6304C16.7133 18.5612 15.245 20.1248 13.434 20.1282Z",
    fill: "#1AD393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.0984 14.7868H15.0968C14.9428 14.7868 14.795 14.8522 14.685 14.9678L12.7891 16.9757L12.176 16.322C11.948 16.079 11.5786 16.079 11.3506 16.322C11.1227 16.565 11.1227 16.9589 11.3506 17.2019L12.3756 18.2947C12.6036 18.536 12.9714 18.5377 13.1994 18.2947L15.5072 15.8494C15.7367 15.6064 15.7367 15.2125 15.5103 14.9695C15.4018 14.8522 15.2525 14.7868 15.0984 14.7852V14.7868Z",
    fill: "#1AD393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.4426 0.5H2.83913C2.65048 0.5 2.46969 0.580447 2.3345 0.722905L0.209083 2.9905C0.0754585 3.13296 0 3.3257 0 3.52682V16.6413C0 17.0603 0.319127 17.4006 0.71214 17.4006H8.16996C8.1055 16.8894 8.1055 16.3715 8.16996 15.8603C9.30026 11.0587 12.85 10.9246 13.8765 10.9899C13.9048 10.9933 13.9315 10.995 13.9567 10.9966C13.963 10.9966 13.9693 10.9983 13.9755 10.9983C14.0101 11.0017 14.04 11.005 14.0652 11.0084C14.0746 11.0101 14.084 11.0101 14.0919 11.0117C14.1076 11.0134 14.1217 11.0151 14.1312 11.0168C14.1469 11.0184 14.1548 11.0201 14.1548 11.0201V1.26089C14.1548 0.840223 13.8356 0.5 13.4426 0.5ZM10.8503 10.8508H3.30131C2.90358 10.8508 2.57974 10.5056 2.58131 10.0799C2.58131 9.65419 2.90515 9.31061 3.30445 9.31061H10.8503C11.2496 9.31229 11.5719 9.65587 11.5719 10.0799C11.5735 10.5056 11.2496 10.8508 10.8503 10.8508ZM10.8503 7.7486H3.30131C2.90358 7.7486 2.57974 7.40335 2.58131 6.97765C2.58131 6.55196 2.90515 6.20838 3.30445 6.20838H10.8503C11.2496 6.21006 11.5719 6.55363 11.5719 6.97765C11.5735 7.40335 11.2496 7.7486 10.8503 7.7486Z",
    fill: "#1AD393"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2074_124383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 21,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedComplaince);
export default __webpack_public_path__ + "static/media/SelectedComplaince.718fcc5aa09d3dcdd538ee32f91e6eb9.svg";
export { ForwardRef as ReactComponent };